/**课程详情统计模块 */
import request from '../request/http';
/**获取开课数据统计 */
export function GetOpenCourseConditionStatistics(data){
    return request({
        url: '/sp/courseStatistics/getOpenCourseConditionStatistics',
        method: 'post',
        data
    })
}
/**获取课程教学单元数量 */
export function GetCourseTeachingUnit(data){
    return request({
        url: '/sp/courseStatistics/getCourseTeachingUnit',
        method: 'post',
        data
    })
}
/**获取课程资源统计 */
export function GetCourseResStatistics(data){
    return request({
        url: '/sp/courseStatistics/getCourseResStatistics',
        method: 'post',
        data
    })
}
/**获取随堂测试数据 */
export function GetClassroomTestData(data){
    return request({
        url: '/sp/courseStatistics/getClassroomTestData',
        method: 'post',
        data
    })
}
/**获取课程考试数据 */
export function GetCourseExamData(data){
    return request({
        url: '/sp/courseStatistics/getCourseExamData',
        method: 'post',
        data
    })
}
/**获取开课数据统计曲线图 */
export function GetOpenCourseCurveData(data){
    return request({
        url: '/sp/courseStatistics/getOpenCourseCurveData',
        method: 'post',
        data
    })
}
/**获取课程任务数量 */
export function GetCourseTaskCount(data){
    return request({
        url: '/sp/courseStatistics/getCourseTaskCount',
        method: 'post',
        data
    })
}